import VerofreshRecord from './VerofreshRecord'

class ReportRecord extends VerofreshRecord {
  // icons for old UI
  getIcon () {
    switch (this.type) {
      case 'SiteViolationReport':
        return 'map-marker-alt'
      case 'MonthlyRouteStatusReport':
        return 'road'
      case 'VehicleViolationReport':
        return 'truck'
      case 'RootCauseReport':
        return 'balance-scale'
      case 'MissedStopsReport':
        return 'flag'
      case 'CustomerMetricsReport':
        return 'building'
      case 'StartTemperaturesReport':
        return 'thermometer-half'
      case 'FleetHealthReport':
        return 'lightbulb'
      case 'RouteDataQualityReport':
        return 'clipboard-list'
      case 'RouteAssessmentMetricsReport':
        return 'clipboard-list'
      case 'FleetHealthHistoryReport':
        return 'clipboard-list'
      case 'RoutePlanHistoryReport':
        return 'clipboard-list'
      case 'TemperatureViolationHistoryReport':
        return 'clipboard-list'
      case 'RootCauseAnalysisHistoryReport':
        return 'clipboard-list'
      case 'WeeklyPerformanceReport':
        return 'clipboard-list'
      case 'WeeklyScorecardReport':
        return 'clipboard-list'
      case 'ForecastViolationValidationReport':
        return 'clipboard-check'
    }
  }

  // icons for new ui
  get mdiIcon () {
    switch (this.type) {
      case 'SiteViolationReport':
        return 'mdi-store-alert'
      case 'MonthlyRouteStatusReport':
        return 'mdi-road'
      case 'VehicleViolationReport':
        return 'mdi-truck-alert'
      case 'RootCauseReport':
        return 'mdi-scale-balance'
      case 'MissedStopsReport':
        return 'mdi-map-marker-alert'
      case 'CustomerMetricsReport':
        return 'mdi-office-building'
      case 'StartTemperaturesReport':
        return 'mdi-thermometer'
      case 'FleetHealthReport':
        return 'mdi-lightbulb'
      case 'RouteDataQualityReport':
        return 'mdi-clipboard-list'
      case 'RouteAssessmentMetricsReport':
        return 'mdi-clipboard-list'
      case 'FleetHealthHistoryReport':
        return 'mdi-clipboard-list'
      case 'RoutePlanHistoryReport':
        return 'mdi-clipboard-list'
      case 'TemperatureViolationHistoryReport':
        return 'mdi-clipboard-list'
      case 'RootCauseAnalysisHistoryReport':
        return 'mdi-clipboard-list'
      case 'WeeklyPerformanceReport':
        return 'mdi-clipboard-list'
      case 'WeeklyScorecardReport':
        return 'mdi-clipboard-list'
      case 'ForecastViolationValidationReport':
        return 'mdi-clipboard-check'
    }
  }
}

export default ReportRecord
